import React, { useEffect, useState } from "react";

import Bloc2 from "./Bloc2";
import Bloc1 from "./Bloc1";
import Bloc4 from "./Bloc4";
import { Link, useNavigate } from "react-router-dom";
import { Skeleton } from "@mui/material";
import { INoticeDetails } from "../../../models/interfaces/INotice";
import Bloc6 from "./Bloc6";
import { toast } from "react-toastify";
import { ModificationBloque } from "../../../config/helpers";
interface IProps {
  NoticeResult: INoticeDetails|undefined;
  isFetchingNoticeResult:boolean;
  btnModifierAutoVisible:boolean;
  btnModifierMessageVisible:boolean;
}

const NoticeDetailsPreview: React.FC<IProps> = ({ NoticeResult,isFetchingNoticeResult, btnModifierAutoVisible,btnModifierMessageVisible}) => {
  const [pathSource, setPathSource] = useState<string>("");
  const navigate = useNavigate();


  useEffect(() => {
    const pathParts = location.pathname.split("/").filter(Boolean); // Supprime les éventuels espaces vides

    if (pathParts.length >= 1 ) {
      setPathSource(`/${pathParts[0]}`);

      }
  }, [location.pathname, navigate]);

  const ModificationMessageBloqueMessage = ModificationBloque(
    NoticeResult?.Source ?? "",
    NoticeResult?.Support?.supportId ?? "",
    "Modifcations par message impossible pour cette notice.");

    const ModificationAutoBloqueMessage = ModificationBloque(
      NoticeResult?.Source ?? "",
      NoticeResult?.Support?.supportId ?? "",
      "Modifcations automatisés impossible pour cette notice.");

      
  
   return (
    <>
        {
      (!NoticeResult ||isFetchingNoticeResult) ?  
      <div className="card pae-detail-pub-card">
        <div className="card-body pae-form-container row">
          <Skeleton variant="rectangular" className="col-12" height="220px" />
        </div>
      </div>
      :
    <>
     <div className="card pae-detail-pub-card">
      <div className="card-body pae-form-container row">
        <div className="col-2 mt-2">
          {/* Fin Bloc 1      */}
            <div className="pae-detail-linked-file">
            {/* Début Bloc 2     */}
              <>
                <Bloc2 NoticeResult={NoticeResult}></Bloc2>
                {(btnModifierAutoVisible || btnModifierMessageVisible) && 
                  <div className="card mt-1 mb-2" style={{ textAlign: 'left' }}>
                  {btnModifierAutoVisible && 
                  <Link
                  to={ModificationAutoBloqueMessage === undefined ? `${pathSource}/noticedetailsmodifauto/${NoticeResult?.Ean}/${NoticeResult?.Id}` : ""}
                  className={`App-link ${ModificationAutoBloqueMessage === undefined ? 'btn btn-secondary' : 'btn btn-red'} d-flex mt-1 mb-1`}
                  onClick={ModificationAutoBloqueMessage !== undefined ? () => toast.error(ModificationAutoBloqueMessage) : undefined}
                >
                  <i className="bi-pencil-square pe-2 App-icon-size" /><br />
                  <div className="desktop-only-section">Modifier</div>
                </Link>
                  }
                  {btnModifierMessageVisible &&  
                     <Link
                     to={ModificationMessageBloqueMessage === undefined ? `${pathSource}/noticedetailsmessage/${NoticeResult?.Ean}/${NoticeResult?.Id}` : ""}
                     className={`App-link ${ModificationMessageBloqueMessage === undefined ? 'btn btn-secondary' : 'btn btn-red'} d-flex mt-1 mb-1`}
                     onClick={ModificationMessageBloqueMessage !== undefined ? () => toast.error(ModificationMessageBloqueMessage) : undefined}
                   >
                     <i className="bi-chat-left-text pe-2 App-icon-size" />
                     <div className="desktop-only-section">Modifier</div>
                   </Link>
                    
                  }
                  {/* /noticedetails/ */}
                  </div>
                }
              </>
            </div>
        </div>
        <div className="col-10 mt-2">
          <div className="mb-2">
            <Bloc1 NoticeResult={NoticeResult}></Bloc1>
          </div>
          <Bloc4 NoticeResult={NoticeResult}></Bloc4>
          <Bloc6 NoticeResult={NoticeResult}></Bloc6>
            {/* {NoticeResult.Titre}
            {NoticeResult.Auteurs}
            Marque:
            Ean:
            Distributeur:
            Support: */}
        </div>
      </div>
    </div>
   
    </>
    }
    </>
  );
};

export default NoticeDetailsPreview;
